import { create } from '@storybook/theming';
import logo from './logo.png';

export default create({
  base: 'dark',
  brandTitle: 'IteaMDB kit',
  brandImage: logo,
});
